import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Prov from '@material-ui/core/Popover'

function Popover({
  children,
  trigger,
  anchorOrigin,
  transformOrigin,
  handleActive,
  className,
  unsetOverflow,
  boxNoPadding,
  onHover,
  testId,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)
  const id = open ? Math.floor(Math.random() * Math.floor(1000)) : undefined

  React.useEffect(() => {
    if (handleActive) handleActive(open)
  }, [open])

  return (
    <div>
      <div
        className="popover_box--trigger"
        aria-describedby={id}
        onClick={handleClick}
        onMouseEnter={onHover && handleClick}
      >
        {trigger}
      </div>
      <Prov
        className={classNames('jisr-popover', className)}
        data-testid={testId}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          ...anchorOrigin,
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
          ...transformOrigin,
        }}
      >
        <div
          className={classNames(
            'popover_box',
            boxNoPadding && 'popover_box--no-padding',
            transformOrigin.horizontal || 'left',
            transformOrigin.vertical === 'center' && 'no_padding',
          )}
          style={{ ...(unsetOverflow && { overflow: 'unset' }) }}
        >
          {children}
        </div>
      </Prov>
    </div>
  )
}

Popover.propTypes = {
  children: PropTypes.node,
  trigger: PropTypes.node,
  anchorOrigin: PropTypes.shape(),
  transformOrigin: PropTypes.shape(),
  handleActive: PropTypes.func,
  className: PropTypes.string,
  boxNoPadding: PropTypes.bool,
  unsetOverflow: PropTypes.bool,
  onHover: PropTypes.func,
  testId: PropTypes.string,
}

Popover.defaultProps = {
  transformOrigin: {},
  anchorOrigin: {},
}

export default Popover
